import React from "react"
import classes from "./CustomCalendarHead.module.css"
import { CalendarDate } from "../types"
import { getMonthName } from "../utils"
import CustomCalendarButton from "../CustomCalendarButton"
import { BackArrowIcon, ForwardArrowIcon } from "../../../icons"

interface Props {
  currentPageDate: CalendarDate
  className?: string
  showControls?: boolean
  onNextMonthClick?: () => void
  onPrevMonthClick?: () => void
  min?: CalendarDate
  max?: CalendarDate
}

const getMonthLabel = (d: CalendarDate) => `${getMonthName(d)} ${d.year}`

const CustomCalendarHead = ({
  currentPageDate,
  showControls,
  onNextMonthClick,
  onPrevMonthClick,
  min,
  max,
  className,
}: Props) => {
  const canGoBack = () =>
    !min ||
    currentPageDate.year > min.year ||
    (currentPageDate.year === min.year && currentPageDate.month > min.month)

  const canGoForward = () =>
    !max ||
    currentPageDate.year < max.year ||
    (currentPageDate.year === max.year && currentPageDate.month < max.month)

  return (
    <div className={`${classes.root} ${className ?? ""}`}>
      <span className={classes.label}>{getMonthLabel(currentPageDate)}</span>
      <div className={classes.controls}>
        <CustomCalendarButton
          disabled={!canGoBack()}
          onClick={() => {
            if (!canGoBack()) {
              return
            }
            onPrevMonthClick?.()
          }}
          className="mr-4"
        >
          <BackArrowIcon />
        </CustomCalendarButton>
        <CustomCalendarButton
          disabled={!canGoForward()}
          onClick={() => {
            if (!canGoForward()) {
              return
            }
            onNextMonthClick?.()
          }}
        >
          <ForwardArrowIcon />
        </CustomCalendarButton>
      </div>
    </div>
  )
}

export default CustomCalendarHead
